import { Spin, Alert, Button } from 'antd';
import Board from '../components/Board';

import { useGetTodoByIdQuery, useRestoreTodoMutation } from '../store/todos'
import { useParams } from 'react-router-dom';

const TodoDetailsPage = () => {
    const { todoId, projectUrl = '' } = useParams();
    const { data, error, isLoading } = useGetTodoByIdQuery({ todoId: Number(todoId) });
    const [restoreTodo, { isLoading: isRestoring }] = useRestoreTodoMutation();

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (error || !data) {
        return (
            <div className="app-page">
                <div className="app-empty">Не удалось загрузить доску. Проверьте доступ или обновите страницу.</div>
            </div>
        );
    }

    const isArchived = Boolean(data.archivedAt);

    return (
        <>
            {isArchived && (
                <Alert
                    type="warning"
                    showIcon
                    banner
                    message="Эпик в архиве"
                    description="Эпик скрыт из основного списка. Его можно восстановить."
                    action={
                        <Button
                            size="small"
                            type="primary"
                            loading={isRestoring}
                            onClick={() => restoreTodo({
                                todoId: Number(todoId),
                                projectUrl,
                                todoName: data.todoName,
                                trackerKey: data.trackerKey ?? null,
                            })}
                        >
                            Восстановить
                        </Button>
                    }
                />
            )}
            <Board groups={data.groups} todoId={Number(todoId)} />
        </>
    );
};

export default TodoDetailsPage;
